/* eslint-disable react-hooks/exhaustive-deps */
import {createContext, FC, useContext, useEffect, useMemo, useState} from 'react'
import {WithChildren} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'

type ToursListFiltersContextValue = {
  searchInput: string
  setSearchInput: (value: string) => void
  statusFilter: string
  setStatusFilter: (value: string) => void
  categoryFilter: string
  setCategoryFilter: (value: string) => void
  cityFilter: string
  setCityFilter: (value: string) => void
  typeFilter: string
  setTypeFilter: (value: string) => void
  activeSearch: string
}

const ToursListFiltersContext = createContext<ToursListFiltersContextValue | undefined>(undefined)

const ToursListFiltersProvider: FC<WithChildren> = ({children}) => {
  const {updateState} = useQueryRequest()
  const [searchInput, setSearchInput] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [categoryFilter, setCategoryFilter] = useState('')
  const [cityFilter, setCityFilter] = useState('')
  const [typeFilter, setTypeFilter] = useState('')

  const activeSearch = useMemo(() => searchInput.trim(), [searchInput])

  useEffect(() => {
    updateState({
      page: 0,
      search: activeSearch || undefined,
      status: statusFilter || undefined,
      category: categoryFilter || undefined,
      city: cityFilter || undefined,
      types: typeFilter || undefined,
    })
  }, [activeSearch, statusFilter, categoryFilter, cityFilter, typeFilter, updateState])

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      statusFilter,
      setStatusFilter,
      categoryFilter,
      setCategoryFilter,
      cityFilter,
      setCityFilter,
      typeFilter,
      setTypeFilter,
      activeSearch,
    }),
    [
      searchInput,
      statusFilter,
      categoryFilter,
      cityFilter,
      typeFilter,
      activeSearch,
    ],
  )

  return (
    <ToursListFiltersContext.Provider value={value}>{children}</ToursListFiltersContext.Provider>
  )
}

const useToursListFilters = (): ToursListFiltersContextValue => {
  const context = useContext(ToursListFiltersContext)
  if (!context) {
    throw new Error('useToursListFilters must be used within ToursListFiltersProvider')
  }
  return context
}

export {ToursListFiltersProvider, useToursListFilters}
